// src/pages/index.js

function toCamelCase(str) {
    return str
        .replace(/[-_](.)/g, (_, group1) => group1.toUpperCase()) // handle kebab/snake
        .replace(/^(.)/, (_, group1) => group1.toUpperCase());    // capitalize first
}

function importAll(r) {
    let modules = {};
    r.keys().forEach((key) => {
        // "./dashboard/index.js" → "dashboard"
        const folder = key.split("/")[1];
        const name = toCamelCase(folder);
        modules[name] = r(key).default;
    });
    return modules;
}

export const pagesMap = {...importAll(require.context("./", true, /index\.js$/)),
    Goal: require("./goals/goal/goal.js").default,
    Project: require("./projects/project.js").default,
    ReportDashboard: require("./reports/report-dashboard.js").default,
    Post: require("./help/post.js").default,
    GoalUpdateStatus: require("./goals/components/goal-update-status.js").default,
    ProjectUpdateStatus: require("./projects/components/project-update-status").default,
    Team: require("./teams/team.js").default,
    Customer: require("./customers/customer.js").default,
    SmartFormBuilder: require("./smart-forms/builder.js").default,
};



// export const pagesMap = {
//     Dashboard,
//     Devices,
//     Webhooks,
//     Programs,
//     SingleSend,
//     Contacts,
//     UserAccount,
//     Templates,
//     ChatBots,
//     Settings,
//     Campaigns
// }
